export const templateQueryKeys = {
  all: ['templates'] as const,

  // User templates
  userTemplates:     ()                   => [...templateQueryKeys.all, 'user'] as const,
  userTemplateList:  (params?: object)    => [...templateQueryKeys.userTemplates(), 'list', params] as const,
  userTemplateById:  (id: string)         => [...templateQueryKeys.userTemplates(), 'detail', id] as const,
  userTemplateByTool:(tool: string)       => [...templateQueryKeys.userTemplates(), 'by-tool', tool] as const,
  resolvedTemplate:  (tool: string)       => [...templateQueryKeys.all, 'resolved', tool] as const,

  // System templates
  systemTemplates:   ()                   => [...templateQueryKeys.all, 'system'] as const,
  systemTemplateList:()                   => [...templateQueryKeys.systemTemplates(), 'list'] as const,
  systemTemplateByTool:(tool: string)     => [...templateQueryKeys.systemTemplates(), tool] as const,

  // Enterprise templates (org-level)
  enterpriseTemplates:    ()              => [...templateQueryKeys.all, 'enterprise'] as const,
  enterpriseTemplateList: (params?: object) => [...templateQueryKeys.enterpriseTemplates(), 'list', params] as const,
  enterpriseTemplateById: (id: string)   => [...templateQueryKeys.enterpriseTemplates(), 'detail', id] as const,

  // Product templates (workspace-level)
  productTemplates:    ()                => [...templateQueryKeys.all, 'product'] as const,
  productTemplateList: (params?: object) => [...templateQueryKeys.productTemplates(), 'list', params] as const,
  productTemplateById: (id: string)      => [...templateQueryKeys.productTemplates(), 'detail', id] as const,
} as const;

